export default __webpack_public_path__ + "static/look-5-9c707361e4055a52b743066ae9278526.png";